import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import { Employee } from "generated/graphql";
import useArchiveEmployee from "hooks/organization/employees/useArchiveEmployee";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function Archive({ closeMenu, id }: { closeMenu: () => void; id: Employee["id"] }) {
  const [archiveEmployee, { isSuccess }] = useArchiveEmployee();

  const acceptFn = useCallback(async (): Promise<boolean> => {
    const result = await archiveEmployee({ variables: { id } });
    const success = isSuccess(result.data);
    if (success) {
      closeMenu();
    }
    return success;
  }, []);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Archive employee?"
        content="This employee will be hidden from lists and dropdowns, but their time records and history will be preserved. You can restore them later from Archived Employees."
        acceptText="Archive"
      />
      <MenuItem onClick={() => setOpen(true)}>Archive</MenuItem>
    </>
  );
}
